import { useMock, corporateGet, corporatePost, corporatePut, corporateDelete } from './client';
import courseAssignmentsMock from '@/mocks/corporate/courseAssignments';

const SCHEMA_GAP =
    'Operação indisponível no schema atual (reprocessamento de liberações).';

function schemaGapError() {
    const error = new Error(SCHEMA_GAP);
    error.code = 'SCHEMA_GAP';
    return error;
}

export default {
    async list(accessToken, params = {}) {
        if (useMock()) return courseAssignmentsMock.list(accessToken, params);
        return corporateGet('/corporate/course-assignments', accessToken, {
            search: params.search || undefined,
            resourceType: params.resourceType || undefined,
            sectorId: params.sectorId || undefined,
            roleId: params.roleId || undefined,
            status: params.status || undefined,
            page: params.page != null ? params.page : 0,
            size: params.size != null ? params.size : 200,
        });
    },

    async preview(accessToken, payload) {
        if (useMock()) return courseAssignmentsMock.preview(accessToken, payload);
        const response = await corporatePost('/corporate/course-assignments/preview', payload, accessToken);
        return {
            impactedUsers: response?.totalElements ?? response?.impactedUsers ?? 0,
            content: response?.content || [],
        };
    },

    async create(accessToken, payload) {
        if (useMock()) return courseAssignmentsMock.create(accessToken, payload);
        return corporatePost('/corporate/course-assignments', payload, accessToken);
    },

    async update(id, payload, accessToken) {
        if (useMock()) return courseAssignmentsMock.update(accessToken, id, payload);
        return corporatePut(`/corporate/course-assignments/${id}`, payload, accessToken);
    },

    async remove(accessToken, id) {
        if (useMock()) return courseAssignmentsMock.remove(accessToken, id);
        return corporateDelete(`/corporate/course-assignments/${id}`, accessToken);
    },

    async reseed(accessToken) {
        if (useMock()) return courseAssignmentsMock.reseed(accessToken);
        throw schemaGapError();
    },
};

export { matchesRule } from '@/utils/corporate/accessRules';
